import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuthentication from "../../Services/Authentication/useAuthentication";

interface IProps {
    children?: JSX.Element;
}

export default function AnonymousRouteProvider({ children }: IProps) {
    const { isAuthenticated, user } = useAuthentication();
    const location = useLocation();
    const { from } = location.state || { from: { pathname: "/dashboard" } };
    const redirection = from !== "/logout" ? from : "/";

    if (user && !user.phoneVerified) {
        return <Navigate to={`/verify-phone`} replace />;
    }

    if (!isAuthenticated) {
        return children ? children : <Outlet />;
    } else {
        return <Navigate to={redirection} replace />;
    }
}
